var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 480 480.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e2e9ff",
    d: "M280 232c0 22.09-17.906 40-40 40-22.09 0-40-17.91-40-40s17.91-40 40-40c22.094 0 40 17.91 40 40zM416 264c0 22.09-17.906 40-40 40-22.09 0-40-17.91-40-40s17.91-40 40-40c22.094 0 40 17.91 40 40zM144 264c0 22.09-17.906 40-40 40-22.09 0-40-17.91-40-40s17.91-40 40-40c22.094 0 40 17.91 40 40zM208 296h64c35.348 0 64 28.652 64 64v80c0 17.672-14.328 32-32 32H176c-17.672 0-32-14.328-32-32v-80c0-35.348 28.656-64 64-64zm0 0",
    opacity: 1,
    "data-original": "#9bc9ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2e9ff",
    d: "M344 328h64c35.348 0 64 28.652 64 64v32c0 26.508-21.488 48-48 48H280v-80c0-35.348 28.656-64 64-64zM200 472H56c-26.508 0-48-21.492-48-48v-32c0-35.348 28.656-64 64-64h64c35.348 0 64 28.652 64 64zm0 0",
    opacity: 1,
    "data-original": "#9bc9ff",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1e81ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432 264v-16a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-43.2l-1.55-6.008a147.808 147.808 0 0 0-16.32-39.09l-3.2-5.351 30.672-30.727a7.931 7.931 0 0 0 0-11.199l-33.976-34.023a8.113 8.113 0 0 0-11.203 0l-30.727 30.726-5.351-3.2a148.13 148.13 0 0 0-39.137-16.327L272 67.238V24a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v43.2l-6.008 1.554a148.116 148.116 0 0 0-39.094 16.308l-5.355 3.204-30.719-30.664a8.111 8.111 0 0 0-11.238 0L81.602 91.574a7.944 7.944 0 0 0 0 11.25l30.726 30.727-3.2 5.351a147.808 147.808 0 0 0-16.32 39.09L91.243 184H48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8v16c-13.254 0-24-10.746-24-24v-48c0-13.254 10.746-24 24-24h30.953a163.432 163.432 0 0 1 13.313-31.863l-22-22a23.92 23.92 0 0 1 0-33.871l34-34c9.472-9.067 24.406-9.067 33.879 0l21.992 21.992A163.476 163.476 0 0 1 192 54.96V24c0-13.254 10.746-24 24-24h48c13.254 0 24 10.746 24 24v30.96a163.404 163.404 0 0 1 31.863 13.306l22-22c9.477-9.067 24.407-9.067 33.883 0l33.992 33.992a23.933 23.933 0 0 1 0 33.871l-22 22A163.828 163.828 0 0 1 401.047 168H432c13.254 0 24 10.746 24 24v48c0 13.254-10.746 24-24 24zm0 0",
    fill: "#22419e",
    opacity: 1,
    "data-original": "#1e81ce",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 216h-16c0-53.02-42.98-96-96-96s-96 42.98-96 96h-16c0-61.855 50.145-112 112-112s112 50.145 112 112zm0 0",
    fill: "#22419e",
    opacity: 1,
    "data-original": "#1e81ce",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 280c-26.508 0-48-21.492-48-48s21.492-48 48-48c26.512 0 48 21.492 48 48-.027 26.5-21.5 47.973-48 48zm0-80c-17.672 0-32 14.328-32 32s14.328 32 32 32 32-14.328 32-32-14.328-32-32-32zM376 312c-26.508 0-48-21.492-48-48s21.492-48 48-48c26.512 0 48 21.492 48 48-.027 26.5-21.5 47.973-48 48zm0-80c-17.672 0-32 14.328-32 32s14.328 32 32 32 32-14.328 32-32-14.328-32-32-32zM104 312c-26.508 0-48-21.492-48-48s21.492-48 48-48c26.512 0 48 21.492 48 48-.027 26.5-21.5 47.973-48 48zm0-80c-17.672 0-32 14.328-32 32s14.328 32 32 32 32-14.328 32-32-14.328-32-32-32zm0 0",
    fill: "#22419e",
    opacity: 1,
    "data-original": "#1e81ce",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.527 332.527A71.205 71.205 0 0 0 408 320h-64c-3.89.035-7.773.387-11.61 1.055a71.723 71.723 0 0 0-19.59-20.328 30.883 30.883 0 0 0-3.687-2.399A71.442 71.442 0 0 0 272 288h-64a71.2 71.2 0 0 0-60.367 33.055A71.72 71.72 0 0 0 136 320H72a71.193 71.193 0 0 0-40.504 12.512A72.001 72.001 0 0 0 0 392v32a56.05 56.05 0 0 0 32.578 50.832A54.24 54.24 0 0 0 56 480h80v-16H64v-88H48v87.2a37.599 37.599 0 0 1-8.71-2.895A40.064 40.064 0 0 1 16 424v-32a56.061 56.061 0 0 1 24.527-46.29A55.35 55.35 0 0 1 72 336h64c1.41 0 2.77.152 4.145.246A71.972 71.972 0 0 0 136 360v80c.027 22.082 17.922 39.973 40 40h24V352h-16v112h-8c-13.254 0-24-10.746-24-24v-80c0-30.93 25.074-56 56-56h64a55.916 55.916 0 0 1 29.16 8.23c.813.446 1.594.946 2.336 1.497a56.666 56.666 0 0 1 17.938 20A55.876 55.876 0 0 1 328 360v80c0 13.254-10.746 24-24 24h-8V352h-16v128h24c22.082-.027 39.973-17.918 40-40v-80a72.082 72.082 0 0 0-4.137-23.754c1.38-.094 2.739-.246 4.137-.246h64a55.371 55.371 0 0 1 31.496 9.727A56.057 56.057 0 0 1 464 392v32a40.054 40.054 0 0 1-23.422 36.367A36.901 36.901 0 0 1 432 463.2V376h-16v88h-72v16h80a54.077 54.077 0 0 0 23.29-5.105A56.068 56.068 0 0 0 480 424v-32a71.996 71.996 0 0 0-31.473-59.473zm0 0",
    fill: "#22419e",
    opacity: 1,
    "data-original": "#1e81ce",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 464h64v16h-64zm0 0",
    fill: "#22419e",
    opacity: 1,
    "data-original": "#1e81ce",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin01);
export default __webpack_public_path__ + "static/media/admin-01.b121f7a4eae4daeccb2a44ccc9b03158.svg";
export { ForwardRef as ReactComponent };